<template>
	<div class="w-100 bg-white">
		<span class="position-relative" style="top:-50px" id="room-type-detail"></span>
		<!-- <Header></Header> -->
		<div class="hide-768px">
			<HomeNavbarDesktop @shareClick="shareClick" @callClick="callClick" @goToBookingPage="goToBookingPage" />
		</div>
		<div class="show-768px">
			<HomeNavbarMobile @shareClick="shareClick" @callClick="callClick" />
		</div>
		<div v-if="is_load" class="w-100 py-5 mt-5 text-center">
      <loader />
    </div>
		<div class="px-10 mt-5 bg-white" v-else>
		 	<div class="row no-gutters mb-5">
					<div class="col-12 col-xl-7 mt-5 pt-3">
						<div class="d-inline-block mb-4 cursor-pointer">
							<div class="" @click="$router.go(-1)">
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fill-rule="evenodd" clip-rule="evenodd" d="M16.9107 10.6857C17.2435 10.6399 17.5 10.3504 17.5 10.0001C17.5 9.61795 17.1947 9.30816 16.8182 9.30816L4.83339 9.30816L9.16276 4.93222L9.22893 4.85475C9.42753 4.58429 9.40631 4.19984 9.16475 3.95368C8.89904 3.6829 8.46733 3.68199 8.20052 3.95165L2.71023 9.50036C2.67753 9.53215 2.64794 9.56722 2.62198 9.60504C2.43614 9.87525 2.46234 10.2501 2.70056 10.4908L8.20056 16.0484L8.27717 16.1152C8.54452 16.3156 8.92325 16.2925 9.16479 16.0463C9.43048 15.7755 9.42955 15.3374 9.16271 15.0677L4.83231 10.692L16.8182 10.692L16.9107 10.6857Z" fill="#222222"/>
								</svg>
								<p class="mb-0 d-inline-block body-1-2 ml-1 top-2 position-relative font-medium text-18">Back</p>
							</div>
						</div>
						<p class="mb-3 body-1-2 font-bold text-32 text-26-m">{{room_type_detail.name}}</p>
						<div class="img-hover-zoom position-relative rounded-6 mb-4">
							<flickity ref="flickity" class="" :options="freeScrollSlider" v-if="room_type_detail.image.length != 0">
					      <div class="carousel-cell w-100" v-for="data in room_type_detail.image">
				        	<div class="img-hover-zoom radius-6">
			    					<img :src="data.image_url"  class="radius-6 img-fit slider-hover h-270px-m" :alt="getMerchant.name" style="height:450px;">
				        	</div>
					      </div>
					    </flickity>
		    			<img :src="image_undefine" v-else class="img-fit slider-hover" :alt="getMerchant.name" style="height:450px;">
							<div class="rounded-6 position-absolute bg-white-light px-3 py-2 cursor-pointer" @click="showGallery(true)" style="bottom:24px;right:24px" v-if="room_type_detail.image.length > 1">
								<svg width="22" height="22" class="d-inline-block mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g id="Iconly/Light/Image">
									<g id="Image">
									<path id="Stroke 1" fill-rule="evenodd" clip-rule="evenodd" d="M21.21 7.89918V16.0502C21.21 19.0702 19.32 21.2002 16.3 21.2002H7.65C4.63 21.2002 2.75 19.0702 2.75 16.0502V7.89918C2.75 4.87918 4.64 2.75018 7.65 2.75018H16.3C19.32 2.75018 21.21 4.87918 21.21 7.89918Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									<path id="Stroke 3" d="M5.28125 16.4309L6.80925 14.8179C7.34025 14.2549 8.22525 14.2279 8.78925 14.7579C8.80625 14.7749 9.72625 15.7099 9.72625 15.7099C10.2813 16.2749 11.1883 16.2839 11.7533 15.7299C11.7903 15.6939 14.0872 12.9079 14.0872 12.9079C14.6792 12.1889 15.7422 12.0859 16.4622 12.6789C16.5102 12.7189 18.6803 14.9459 18.6803 14.9459" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									<path id="Stroke 5" fill-rule="evenodd" clip-rule="evenodd" d="M10.3126 9.13309C10.3126 10.1021 9.52757 10.8871 8.55857 10.8871C7.58957 10.8871 6.80457 10.1021 6.80457 9.13309C6.80457 8.16409 7.58957 7.37909 8.55857 7.37909C9.52757 7.38009 10.3126 8.16409 10.3126 9.13309Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									</g>
									</g>
								</svg>
								<p class="mb-0 d-inline-block body-2-1 text-12">{{$t('general.view-all')}} {{room_type_detail.image.length}} {{$t('hotel.concierge.images')}}</p>
							</div>
						</div>
						<div class="mb-4">
							<p class="mb-3 font-semibold text-20 text-20-m">{{$t('general.description')}}</p>
	  					<div class="d-inline-block box-c-rt bg-light-page-2 mb-3">
	  						<p class="mb-1 body-3 text-14 lh-1">{{$t('hotel.unit-type.'+room_type_detail.type+'.size')}}</p>
	    					<i class="simple-icon-size-fullscreen text-green text-15 d-inline-block align-middle mr-1 font-weight-bold"></i>
	              <p class="mb-0 body-2-1 d-inline-block align-middle text-16">{{room_type_detail.room_size}} m²</p>
	    				</div>
	    				<div class="d-inline-block box-c-rt bg-light-page-2 mb-3">
	  						<p class="mb-1 body-3 text-14 lh-1">{{$t('hotel.room-type.total-unit')}}</p>
	    					<i class="simple-icon-home text-green text-15 d-inline-block align-middle mr-1 font-weight-bold"></i>
								<p class="mb-0 body-2-1 d-inline-block align-middle text-16">{{room_type_detail.total_rooms}} {{$t('hotel.room-type.rooms')}}</p>
	    				</div>
	    				<div class="d-inline-block box-c-rt bg-light-page-2 mb-3">
	    					<p class="mb-1 body-3 text-14 lh-1">{{$t('hotel.room-type.bed-type')}}</p>
	    					<i class="simple-icon-grid text-green text-15 d-inline-block align-middle mr-1 font-weight-bold"></i>
	              <p class="mb-0 body-2-1 d-inline-block align-middle text-16">
	                <template v-for="(bed, index) in room_type_detail.bed">
	                	{{bed.qty}} {{bed.name}}<span v-if="index + 1 < room_type_detail.bed.length">,</span>
	                </template>
	              </p>
	    				</div>
	  				</div>
						<p class="mb-5 pb-5 body-2-2-1 mb-0 lh-25 text-16 text-16-m border-bottom">{{room_type_detail.description}}</p>
						<div class="row slim-grid-row mt-4">
							<div class="col-12 col-lg-4">
								<p class="mb-3 font-semibold text-20 text-20-m">{{$t('hotel.room-type.recommended-occupancy')}}</p>
							</div>
							<div class="col-12 col-lg-8">
								<p class="mb-2 text-16 font-semibold text-16-m lh-25">{{$t('hotel.adults.adult')}}: {{room_type_detail.max_adults}} {{$t('hotel.room-type.guests')}}</p>
					 			<p class="mb-2 text-16 font-semibold text-16-m lh-25">{{$t('hotel.children.children')}}: {{room_type_detail.max_children}} {{$t('hotel.room-type.guests')}}</p>
					 			<p class="mb-0 text-16 font-semibold text-16-m lh-25">{{$t('hotel.infants.infants')}}: {{room_type_detail.max_infant}} {{$t('hotel.room-type.guest')}}</p>
							</div>
							<div class="col-12 border-bottom py-3 mt-3 mb-5" v-if="room_type_detail.facility != ''"></div>
							<div class="col-12 col-lg-4" v-if="room_type_detail.facility != ''">
								<p class="mb-3 font-semibold text-20 text-20-m">{{$t('hotel.room-type.room-facilities')}}</p>
							</div>
							<div class="col-12 col-lg-8" v-if="room_type_detail.facility != ''">
								<div class="row">
									<div class="col-6 mb-3" v-for="fac in room_type_detail.facility">
										<div class="row no-gutters">
											<div class="col-3 col-md-2">
												<img class="w-auto" width="30" height="30" :src="fac.icon" :alt="getMerchant.name">
											</div>
											<div class="col-9 col-md-10 align-self-center">
												<p class="mb-0 font-semibold align-middle text-15">{{fac.name}}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 border-bottom py-3 mt-3 mb-5" v-if="room_type_detail.policy != ''"></div>
							<div class="col-12 col-lg-4" v-if="room_type_detail.policy != ''">
								<p class="mb-3 font-semibold text-20 text-20-m">{{$t('hotel.room-policy')}}</p>
							</div>
							<div class="col-12 col-lg-8" v-if="room_type_detail.policy != ''">
								<ul class="mb-4" v-for="data in room_type_detail.policy">
									<li>
										<p class="mb-1 font-bold body-2-2 text-18">{{data.title}}</p>
									</li>
						 			<p class="mb-2 body-2-2 text-15 font-regular html-desc" v-html="data.description">
						 			</p>
								</ul>
							</div>
							<!-- <div class="col-12 border-bottom pt-3 mt-3" v-if="room_type_detail.policy != ''"></div> -->
						</div>
					</div>
					<div class="col-12 col-xl-5 show-desktop">
						<div class="pl-5 ml-5 sticky" style="top: 100px;">
							<div v-if="Object.keys(getRoomStay).length == 0 && getMerchant.use_booking_engine" class="w-100 border-semi-grey radius-12">
								<div class="p-4">
									<p class="heading-5 mb-2 text-26">{{$t('hotel.concierge.fitur.book-our-rooms')}}</p>
									<template v-if="room_type_detail.best_price != null">
										<p class="body-2-2 mb-0">{{$t('hotel.starting-from')}}</p>
										<p class="body-2-2-3 text-18 text-orange mb-3">{{$formatCurrency(room_type_detail.best_price.final_price)}}</p>
									</template>
									<p class="mb-2 body-3">{{$t('hotel.concierge.fitur.click-to-get-attractive-promos')}}</p>
									<div class="border-semi-grey radius-12 mb-3 cursor-pointer" @click="togglePopupFilter()">
										<div class="w-100 border-b-semi-grey p-3">
											<div class="row no-gutters">
												<div class="col-1 align-self-center">
													<img src="../../assets/img/icon/calendar-dark.png" width="15" :alt="getMerchant.name">
												</div>
												<div class="col-11 align-self-center">
													<div class="w-100 pl-1">
														<p class="mb-0 body-3">{{$t('hotel.date.check-in')}} - {{$t('hotel.date.check-out')}}</p>
														<p class="mb-0 body-2-1">{{$formatDate(getBeFilter.date.check_in)}} - {{$formatDate(getBeFilter.date.check_out)}}</p>
													</div>
												</div>
											</div>
										</div>
										<div class="row no-gutters">
											<div class="col-6 border-r-semi-grey">
												<div class="w-100 p-3">
													<div class="row no-gutters">
														<div class="col-2 align-self-center">
															<img src="../../assets/img/icon/double-user.png" width="15" :alt="getMerchant.name">
														</div>
														<div class="col-10 align-self-center">
															<div style="padding-left:4px;">
																<p class="mb-0 body-3">{{$t('hotel.guests.guests')}}</p>
																<p class="mb-0 body-2-1 text-truncate">{{getBeFilter.guest.adult}} {{$t('hotel.adults.adults')}}, {{getBeFilter.guest.child}} {{$t('hotel.children.children')}}, {{getBeFilter.guest.infant}} {{$t('hotel.infants.infants')}}</p>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="col-6">
												<div class="w-100 p-3">
													<div class="row no-gutters">
														<div class="col-2 align-self-center">
															<img src="../../assets/img/icon/discount-dark.png" width="15" :alt="getMerchant.name">
														</div>
														<div class="col-10 align-self-center">
															<div style="padding-left:4px;">
																<p class="mb-0 body-3">{{$t('hotel.promo.promo-code')}}</p>
																<p class="mb-0 body-2-1 text-truncate">{{getBeFilter.promo_code == '' ? '-' : getBeFilter.promo_code}}</p>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="w-100 radius-12 bg-green p-3 cursor-pointer text-center" @click="goToBookingPage()">
										<p class="mb-0 body-2 text-white">{{$t('hotel.action.book-now')}}</p>
									</div>
								</div>
							</div>
							<div class="mt-4 w-100" v-if="isNotLogin">
								<router-link :to="'/'+getMerchant.code+'/login'">
								    <div class="promo-mobile border-top-3 hover bg-white border-semi-grey radius-12 position-relative px-4 py-3">
											<div class="row no-gutters">
												<div class="col-1">
													<div class="d-inline-block icon">
														<svg width="43" height="41" viewBox="0 0 43 41" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path fill-rule="evenodd" clip-rule="evenodd" d="M32.187 14.0568C32.187 18.7928 28.3898 22.5903 23.6505 22.5903C18.9128 22.5903 15.1139 18.7928 15.1139 14.0568C15.1139 9.32086 18.9128 5.525 23.6505 5.525C28.3898 5.525 32.187 9.32086 32.187 14.0568ZM23.6505 37.775C16.6561 37.775 10.7505 36.6382 10.7505 32.2521C10.7505 27.8645 16.6932 26.768 23.6505 26.768C30.6465 26.768 36.5505 27.9048 36.5505 32.2908C36.5505 36.6785 30.6078 37.775 23.6505 37.775Z" class="fill-primary" />
															<path d="M9.64567 5.28137C9.55286 5.37131 9.51022 5.50139 9.53136 5.62895L9.84992 7.39195C9.8768 7.54138 9.81373 7.69259 9.68867 7.77895C9.56612 7.86854 9.40308 7.87929 9.26942 7.80762L7.68236 6.97987C7.62718 6.95049 7.5659 6.93472 7.50319 6.93293H7.40609C7.3724 6.93794 7.33944 6.94869 7.30934 6.96518L5.72192 7.79687C5.64345 7.83629 5.55458 7.85026 5.4675 7.83629C5.25537 7.79615 5.11383 7.59405 5.14859 7.38084L5.4675 5.61784C5.48865 5.4892 5.446 5.35841 5.3532 5.26704L4.05925 4.01287C3.95104 3.90788 3.91341 3.75021 3.96286 3.60795C4.01088 3.46605 4.13343 3.36249 4.28142 3.3392L6.06234 3.08084C6.19779 3.06687 6.31675 2.98445 6.37767 2.86262L7.16242 1.2537C7.18105 1.21787 7.20506 1.1849 7.23409 1.15695L7.26634 1.13187C7.28318 1.11324 7.30253 1.09783 7.32403 1.08529L7.36309 1.07095L7.424 1.04587H7.57486C7.70959 1.05984 7.8282 1.14047 7.89019 1.26087L8.68534 2.86262C8.74267 2.97979 8.85411 3.06114 8.98275 3.08084L10.7637 3.3392C10.9142 3.3607 11.0399 3.46462 11.0898 3.60795C11.1367 3.75164 11.0962 3.90931 10.9858 4.01287L9.64567 5.28137Z" fill="#FAC02C"/>
															<path d="M3.21053 11.3157C3.16413 11.3607 3.14281 11.4257 3.15338 11.4895L3.31266 12.371C3.32609 12.4457 3.29456 12.5213 3.23203 12.5645C3.17076 12.6093 3.08923 12.6146 3.02241 12.5788L2.22888 12.1649C2.20128 12.1502 2.17065 12.1424 2.13929 12.1415H2.09074C2.0739 12.144 2.05741 12.1493 2.04236 12.1576L1.24866 12.5734C1.20942 12.5931 1.16498 12.6001 1.12145 12.5931C1.01538 12.5731 0.944609 12.472 0.961989 12.3654L1.12145 11.4839C1.13202 11.4196 1.1107 11.3542 1.06429 11.3085L0.417322 10.6814C0.363214 10.6289 0.344401 10.5501 0.369126 10.479C0.393135 10.408 0.45441 10.3562 0.528405 10.3446L1.41886 10.2154C1.48659 10.2084 1.54607 10.1672 1.57653 10.1063L1.96891 9.30185C1.97822 9.28394 1.99023 9.26745 2.00474 9.25348L2.02086 9.24094C2.02928 9.23162 2.03896 9.22391 2.04971 9.21764L2.06924 9.21048L2.0997 9.19794H2.17513C2.24249 9.20492 2.3018 9.24524 2.33279 9.30544L2.73036 10.1063C2.75903 10.1649 2.81475 10.2056 2.87907 10.2154L3.76953 10.3446C3.84478 10.3554 3.90767 10.4073 3.93257 10.479C3.95604 10.5508 3.9358 10.6297 3.88061 10.6814L3.21053 11.3157Z" fill="#FAC02C"/>
															<path d="M7.51082 16.6907C7.46442 16.7357 7.4431 16.8007 7.45367 16.8645L7.61295 17.746C7.62639 17.8207 7.59485 17.8963 7.53232 17.9395C7.47105 17.9843 7.38953 17.9896 7.3227 17.9538L6.52917 17.5399C6.50158 17.5252 6.47094 17.5174 6.43959 17.5165H6.39103C6.37419 17.519 6.35771 17.5243 6.34266 17.5326L5.54895 17.9484C5.50971 17.9681 5.46528 17.9751 5.42174 17.9681C5.31567 17.9481 5.2449 17.847 5.26228 17.7404L5.42174 16.8589C5.43231 16.7946 5.41099 16.7292 5.36459 16.6835L4.71761 16.0564C4.66351 16.0039 4.64469 15.9251 4.66942 15.854C4.69343 15.783 4.7547 15.7312 4.8287 15.7196L5.71916 15.5904C5.78688 15.5834 5.84636 15.5422 5.87682 15.4813L6.2692 14.6769C6.27851 14.6589 6.29052 14.6425 6.30503 14.6285L6.32116 14.6159C6.32958 14.6066 6.33925 14.5989 6.35 14.5926L6.36953 14.5855L6.39999 14.5729H6.47542C6.54279 14.5799 6.60209 14.6202 6.63309 14.6804L7.03066 15.4813C7.05932 15.5399 7.11504 15.5806 7.17936 15.5904L8.06982 15.7196C8.14507 15.7304 8.20796 15.7823 8.23286 15.854C8.25634 15.9258 8.23609 16.0047 8.18091 16.0564L7.51082 16.6907Z" fill="#FAC02C"/>
														</svg>
													</div>
												</div>
												<div class="col-10">
													<div class="d-inline-block ml-3 pl-1">
														<p class="mb-0 body-1-2 text-16 font-bold">{{$t('hotel.concierge.fitur.login.title')}}</p>
														<p class="mb-0 body-1-2 text-12 font-regular">{{$t('hotel.concierge.fitur.login.desc')}}</p>
													</div>
												</div>
												<div class="col-1 text-right">
													<img src="../../assets/img/icon/back-arrow.png" class="mt-3 transform-180" alt="Promo" width="12" :alt="getMerchant.name">
												</div>
											</div>
								    </div>
								  </router-link>
							</div>
						</div>
					</div>
				</div>
		 </div>
		 <div class="pb-4"></div>

		 <!-- FOOTER -->
		<Footer></Footer>

		 <!-- GALLERY -->
    <transition name="fade">
 			<template v-if="is_gallery">
	    	<div class="container">
		      <div class="fixed-top d-block nav-bottom bg-white pop-up fit-to-screen scroll-hide-mobile z-index-1041 w-100">
		        <div class="custom-container-fluid px-0">
		          <div class="row justify-content-center no-gutters">
		            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-8 col-12 position-relative">
		              <div class="container px-4 pb-4">
		              	<div class="position-sticky w-100 bg-white top-0 z-index-1036 py-3">
		              		<div class="row">
		              			<div class="col-12">
		              				<div class="cursor-pointer" @click="showGallery(false)">
			              				<img src="../../assets/img/icon/back.png" class="d-inline-block cursor-pointer" width="20" :alt="getMerchant.name">
									    			<p class="mb-0 body-1-2 d-inline-block position-relative ml-1 cursor-pointer" style="top:1px" width="20">{{$t('general.back')}}</p>
									    		</div>
		              			</div>
		              		</div>
		              	</div>
		              	<div class="row slim-grid-row-1">
			              	<div class="col-6 mb-2" 
			              		:class="{'col-12': index_image_slider == 0 || index_image_slider == 3 || index_image_slider == 8 || room_type_detail.image.length < 3}" 
			              		v-for="(room,index_image_slider) in room_type_detail.image" 
			              		:key="index_image_slider" 
			              		@click="index = index_image_slider">
			              		<img :src="room.image_url" class="object-fit w-100 cursor-pointer h-200px-m" :alt="getMerchant.name" height="400">
			              	</div>
			              </div>
		              </div>
		            </div>
		          </div>
		        </div>
		      </div>
		      <CoolLightBox 
			      :items="room_type_detail.image"
			      srcName="image_url" 
			      :index="index"
			      :closeOnClickOutsideMobile="true"
			      @close="index = null">
			    </CoolLightBox>
		    </div>
  		</template>
	  </transition>

	  <!-- DETAIL FILTER BOOKING ENGINE -->
    <popup-detail 
    	direction="bottom" 
    	:show="popup_filter.show"
    	wrapper_size="mobile"
    	:use_max_size="true"
    	:use_footer="true"
    	title="Book our rooms"
    	@close="togglePopupFilter">
    	<template v-slot:body>
    		<div class="px-4">
	    		<div class="w-100 p-3 border-semi-grey radius-12 mb-3">
	    			<CalendarRoom 
              :date_default="popup_filter.form.date"
              :is_double="false"
              :filter_guest="popup_filter.form.guest"
              only_for_page="homepage"
              @finish="applyDateFilter"
              wrapper_class="body-2-2 font-bold text-14 z-index-1038 w-100"></CalendarRoom>
	    		</div>
	    		<div class="w-100 p-3 border-semi-grey radius-12 mb-3">
	    			<div class="w-100">
		    			<div class="row no-gutters">
								<div class="col-1">
									<img src="../../assets/img/icon/double-user.png" :alt="getMerchant.name" width="15">
								</div>
								<div class="col-11">
									<div style="padding-left:4px;">
										<p class="mb-0 body-3 mt-1 mb-3 pb-3 w-100 border-b-semi-grey-dashed">{{$t('hotel.guests.guests')}}</p>
										<div class="row no-gutters mb-3 pb-3 w-100 border-b-semi-grey-dashed">
											<div class="col-7">
												<p class="mb-0 body-2-1">{{$t('hotel.adults.adults')}}</p>
												<p class="mb-0 body-3-3-1">{{getMerchant.adult_description}}</p>
											</div>
											<div class="col-5 text-center mt-1">
	                      <div class="row py-1 text-right w-100 no-gutters">
	                        <div class="col-4 text-center">
	                          <img src="../../assets/img/icon/decrement.png"
	                            class="cursor-disable border rounded-100 p-2" width="30"
	                            v-if="popup_filter.form.guest.adult <= '1'" :alt="getMerchant.name">
	                          <img src="../../assets/img/icon/minus-black.png"
	                            class="cursor-pointer border rounded-100 p-2" width="30" v-else
	                            @click="toggleCounter('min', 'adult')" :alt="getMerchant.name">
	                        </div>
	                        <div class="col-4 text-center">
	                          <p class="mb-0 body-2-2 font-bold text-16 position-relative" style="top: 3px;">
	                            {{popup_filter.form.guest.adult}}</p>
	                        </div>
	                        <div class="col-4 text-center">
	                          <img src="../../assets/img/icon/plus-black.png"
	                            class="cursor-pointer border rounded-100 p-2" width="30"
	                            @click="toggleCounter('plus', 'adult')" :alt="getMerchant.name">
	                        </div>
	                      </div>
	                    </div>
										</div>
										<div class="row no-gutters mb-3 pb-3 w-100 border-b-semi-grey-dashed">
											<div class="col-7">
												<p class="mb-0 body-2-1">{{$t('hotel.children.children')}}</p>
												<p class="mb-0 body-3-3-1">{{getMerchant.children_description}}</p>
											</div>
											<div class="col-5 text-center mt-1">
	                      <div class="row py-1 text-right w-100 no-gutters">
	                        <div class="col-4 text-center">
	                          <img src="../../assets/img/icon/decrement.png"
	                            class="cursor-disable border rounded-100 p-2" width="30"
	                            v-if="popup_filter.form.guest.child <= '0'" :alt="getMerchant.name">
	                          <img src="../../assets/img/icon/minus-black.png"
	                            class="cursor-pointer border rounded-100 p-2" width="30" v-else
	                            @click="toggleCounter('min', 'child')" :alt="getMerchant.name">
	                        </div>
	                        <div class="col-4 text-center">
	                          <p class="mb-0 body-2-2 font-bold text-16 position-relative" style="top: 3px;">
	                            {{popup_filter.form.guest.child}}</p>
	                        </div>
	                        <div class="col-4 text-center">
	                          <img src="../../assets/img/icon/plus-black.png"
	                            class="cursor-pointer border rounded-100 p-2" width="30"
	                            @click="toggleCounter('plus', 'child')" :alt="getMerchant.name">
	                        </div>
	                      </div>
	                    </div>
										</div>
										<div class="row no-gutters">
											<div class="col-7">
												<p class="mb-0 body-2-1">{{$t('hotel.infants.infants')}}</p>
												<p class="mb-0 body-3-3-1">{{getMerchant.infant_description}}</p>
											</div>
											<div class="col-5 text-center mt-1">
	                      <div class="row py-1 text-right w-100 no-gutters">
	                        <div class="col-4 text-center">
	                          <img src="../../assets/img/icon/decrement.png"
	                            class="cursor-disable border rounded-100 p-2" width="30"
	                            v-if="popup_filter.form.guest.infant <= '0'" :alt="getMerchant.name">
	                          <img src="../../assets/img/icon/minus-black.png"
	                            class="cursor-pointer border rounded-100 p-2" width="30" v-else
	                            @click="toggleCounter('min', 'infant')" :alt="getMerchant.name">
	                        </div>
	                        <div class="col-4 text-center">
	                          <p class="mb-0 body-2-2 font-bold text-16 position-relative" style="top: 3px;">
	                            {{popup_filter.form.guest.infant}}</p>
	                        </div>
	                        <div class="col-4 text-center">
	                          <img src="../../assets/img/icon/plus-black.png"
	                            class="cursor-pointer border rounded-100 p-2" width="30"
	                            @click="toggleCounter('plus', 'infant')" :alt="getMerchant.name">
	                        </div>
	                      </div>
	                    </div>
										</div>
									</div>
								</div>
							</div>
						</div>
	    		</div>
	    		<div class="w-100 p-3 border-semi-grey radius-12 mb-3">
	    			<div class="w-100">
		    			<div class="row no-gutters">
								<div class="col-1">
									<img src="../../assets/img/icon/double-user.png" width="15" :alt="getMerchant.name">
								</div>
								<div class="col-11">
									<div style="padding-left:4px;">
										<p class="mb-0 body-3 mt-1 w-100">{{$t('hotel.promo.promo-code')}}</p>
										<input type="text" class="border-semi-grey radius-12 body-2-1 w-100 p-2" v-model="popup_filter.form.promo_code">
									</div>
								</div>
							</div>
						</div>
	    		</div>
	    	</div>
    	</template>
    	<template v-slot:footer>
    		<div class="px-4 pt-3">
    			<state-button block variant="primary" size="lg" :click="goToBookingPage">{{$t('hotel.action.book-now')}}</state-button>
    		</div>
    	</template>
    </popup-detail>

    <!-- FLOATING MENU -->
    <transition name="fade">
      <template v-if="!is_load">
        <div class="position-relative show-mobile" style="z-index: 1027;">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-bottom d-block" style="bottom:0px">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-xl-12 position-relative">
                    <div class="bg-white px-4 py-12px" style="box-shadow: 0px -3px 13px 0px #0000000f">
                      <div class="row">
                        <template>
                          <div class="col-6">
	                            <p class="mb-0 body-2-2 text-12" style="padding-top:2px">{{$t('merchant.starting-from')}}</p>
	                            <p class="mb-0 body-2-2 text-18 text-orange font-bold d-inline-block">{{$formatCurrency(room_type_detail.best_price.final_price)}}</p>
                          </div>
                          <div class="col-6 text-right" @click="$postLog('HOME','','Clicked Find Rooms')">
														<router-link :to="'/'+getMerchant.code+'/hotel-direct-detail/room_type/room_type/'+room_type_detail.id+''">
															<button type="button" class="g-btn g-btn-primary g-btn-lg" style="padding-top:12px;padding-bottom:12px">{{$t('hotel.action.book-now')}}</button>
														</router-link>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </transition>
		<div class="height-75px show-mobile"></div>
	</div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
	import {calculateFinalPriceConcierge} from '@/utils/index.js'
  import moment from 'moment';
  import Flickity from 'vue-flickity';
  import RoomDiningPreview from '@/components/hotel/general/RoomDiningPreview'
  import ThingsToDoPreview from '@/components/hotel/general/ThingsToDoPreview'
  import SpaPreview from '@/components/hotel/general/SpaPreview'
  import LaundryPreview from '@/components/hotel/general/LaundryPreview'
  import CustomUrl from '@/components/hotel/general/CustomUrl'
  import Facility from '@/components/hotel/general/Facility'
  import DateRangePicker from 'vue2-daterange-picker';
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
	import CoolLightBox from 'vue-cool-lightbox'
	import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
  import CurrencyAndLanguage from '@/components/hotel/be/desktop/CurrencyAndLanguage';
  import PopUpBackground from '@/components/hotel/be/PopUpBackgroundDesktop.vue';
  import CalendarRoom from '@/components/hotel/be/CalendarRoom'
  import VoucherPreview from '@/components/hotel/general/VoucherPreview'
  import GuestBill from '@/components/hotel/general/GuestBill'
  import RoomTypePreview from '@/components/hotel/general/RoomTypePreview'
  import PartnerPreview from '@/components/hotel/general/PartnerPreview'
  import Header from '@/components/hotel/HeaderBE.vue';
  import Footer from '@/components/hotel/Footer.vue';
	import {get} from '@/services/index.js'
	import HomeNavbarDesktop from '@/components/hotel/be/desktop/HomeNavbar'
	import HomeNavbarMobile from '@/components/hotel/be/mobile/HomeNavbar'
  import { applyResolvedTitle } from '../../utils/titleService';
  import { trackPageViewAfterDataLoaded } from '../../utils/analytics';

	export default{
		props: ['data_parent'],
		components:{
			Flickity,
			Footer,
			Header,
			RoomDiningPreview,
			ThingsToDoPreview,
			SpaPreview,
			LaundryPreview,
			CustomUrl,
			Facility,
			DateRangePicker,
			CoolLightBox,
			CurrencyAndLanguage,
			PopUpBackground,
			CalendarRoom,
			VoucherPreview,
			GuestBill,
			RoomTypePreview,
			PartnerPreview,
			HomeNavbarDesktop,
			HomeNavbarMobile
		},
		data(){
			return{
				responsive: {
					mobile_header: false,
				},
				is_gallery: false,
        freeScrollSlider: {
          initialIndex: 0,
          autoPlay: 5000,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: true,
          draggable: true,
          wrapAround: false,
          cellAlign: 'left'
        },
        map:{
          center: { lat: null, lng: null },
          markers: []
        },
        popup_info:{
        	show: false,
        	title: '',
        	body: ''
        },
        popup_filter:{
        	show: false,
        	form:{
        		date: {
        			startDate: moment().toDate(),
        			endDate: moment(moment().toDate()).add(this.$defaultFilterBE('night'),'d').toDate()
        		},
        		guest:{
        			adult: 2,
        			child: 0,
        			infant: 0
        		},
        		promo_code: ''
        	},
        	date_avlb_filter: [],
        	date_month_active: [],
        	min_date: moment().subtract(1, 'd').toDate()
        },
        is_gallery: false,
        index: null,
        popup_active: false,
        year: new Date(),
        reservation_pin: '',
        reservation_pin_error: '',
				image_undefine: 'https://guestapps.s3-ap-southeast-1.amazonaws.com/noimage.png',
				is_load: true,
        room_type_detail: '',
			}
		},
		computed:{
			room_type_id(){
				return this.$route.params.room_type_id
			},
			...mapGetters(['getMerchant','getBeFilter','getRoomStay','isNotLogin','getCurrentUser','getCurrency','getCurrentLanguage','getConciergeAuth','getMerchantTimezone']),
			show_reservation_detail(){
				let is_reservation_exist = this.data_parent.reservation.id
				let is_reservation_statis_valid = this.data_parent.reservation.status == 'SUBMIT_FORM' || this.data_parent.reservation.status == 'PRE_CHECKIN' || this.data_parent.reservation.status == 'CHECKIN'

				return is_reservation_exist && is_reservation_statis_valid ? true : false
			},
			reservation_status(){
				if(this.data_parent.reservation.id){
					let return_data = {
						title: '',
						text_color: '',
						description: ''
					}

					if(this.data_parent.reservation.status == 'SUBMIT_FORM'){
						return_data = {
							title: 'Waiting for Approval',
							text_color: 'text-warning',
							description: 'Your data is waiting for approval by the front office. Please wait until the process done.'
						}
					}else if(this.data_parent.reservation.status == 'PRE_CHECKIN'){
						return_data = {
							title: 'Pre Check In',
							text_color: 'text-info',
							description: this.getConciergeAuth.pin_applied ? 'Your data has been validated. Contact the hotel to check in on the application.' : `Please input the PIN that has been sent via email (${this.data_parent.reservation.guest_profile.email}). This PIN also replace your password account, so please don't share it`
						}
					}else if(this.data_parent.reservation.status == 'CHECKIN'){
						return_data = {
							title: 'Check In',
							text_color: 'text-success',
							description: 'Make yourself comfortable and enjoy all the services we have provided for you.'
						}
					}

					return return_data
				}else{
					return null
				}
			},
			
		},
		watch:{
			
		},
		mounted(){
			document.getElementById('room-type-detail').scrollIntoView({
        behavior: 'smooth'
      });
			this.map.center = {
        lat : this.getMerchant.lat,
        lng : this.getMerchant.lng
      }
      this.map.markers = []
      this.map.markers.push({ position: this.map.center });
      this.loadRoomTypeDetail()
		},
		methods:{
			...mapMutations(['setBeFilter','setBeFilterDetail']),
			showGallery(data){
      	this.is_gallery = data
      	document.querySelector('body').style.overflow = data ? 'hidden' : 'auto';
      },
      headerMobile(){
				this.responsive.mobile_header = !this.responsive.mobile_header
			},
			openGuestBill(){
				this.$refs.guest_bill.toggleDetail()
			},
			callClick(){
				this.$emit('callClick')
			},
			formatTime(time){
        return moment(time, 'HH:mm:ss').format('HH:mm')
      },
      detailPromotion(){
      	this.$postLog("HOME","PROMOTION","Clicked promotion")
      },
      goToSearchRoom(){
      	this.$postLog("HOME","PREVIEW BOOK ROOM","Clicked book now")
      	this.$router.push(`/${this.getMerchant.code}/booking`)
      },
      printBestMenuPrice(product){
				let price = product.variant_list.length == 0 ? product.price : product.variant_list[0].price
				return calculateFinalPriceConcierge(price)
			},
			applyDateFilter(date){
	      this.popup_filter.form.date = date
	    },
			shareClick(){
        this.$emit("shareClick")
      },
      togglePopupInfo(title='',body=''){
      	this.popup_info.show = !this.popup_info.show
    		this.popup_info.title = title
    		this.popup_info.body = body
    		this.$postLog('HOME','FOOTER',`Clicked detail ${title}`)
      },
      detailModuleClick(code){
      	this.$emit('detailModuleClick',code)
      },
      goToDetailSlider(slider){
      	this.$emit('goToDetailSlider',slider)
      },
      togglePopupFilter(){
      	this.popup_filter.show = !this.popup_filter.show
      	if(this.popup_filter.show){
      		let cloned_data = this.$deepCopy(this.getBeFilter)
      		this.popup_filter.form = {
        		date: {
        			startDate: cloned_data.date.check_in,
        			endDate: cloned_data.date.check_out
        		},
        		guest:cloned_data.guest,
        		promo_code: cloned_data.promo_code
        	}
      	}else{
      		this.popup_filter.form = {
        		date: {
        			startDate: moment().toDate(),
        			endDate: moment(moment().toDate()).add(this.$defaultFilterBE('night'),'d').toDate()
        		},
        		guest:{
        			adult: this.$defaultFilterBE('adult'),
        			child: 0,
        			infant: 0
        		},
        		promo_code: ''
        	}
      	}
      },
      formatCustomDate(data,frmt){
      	return moment(data).format(frmt)
      },
      goToBookingPage(){
      	return new Promise((success,fail)=>{
      		let use_other_booking_engine = this.getMerchant.use_custom_booking_engine_landing_page
      		if(use_other_booking_engine){
      			let parsed_url = this.getMerchant.custom_booking_engine_landing_page_url
      			let params = [
	  					{ name: "Checkin Date (DD)", parameter: "{{checkin_date}}", value: this.formatCustomDate(this.popup_filter.form.date.startDate,'DD') },
						  { name: "Checkin Month (MM)", parameter: "{{checkin_month}}", value: this.formatCustomDate(this.popup_filter.form.date.startDate,'MM') },
						  { name: "Checkin Year (YYYY)", parameter: "{{checkin_year}}", value: this.formatCustomDate(this.popup_filter.form.date.startDate,'YYYY') },
						  { name: "Checkout Date (DD)", parameter: "{{checkout_date}}", value: this.formatCustomDate(this.popup_filter.form.date.endDate,'DD') },
						  { name: "Checkout Month (MM)", parameter: "{{checkout_month}}", value: this.formatCustomDate(this.popup_filter.form.date.endDate,'MM') },
						  { name: "Checkout Year (YYYY)", parameter: "{{checkout_year}}", value: this.formatCustomDate(this.popup_filter.form.date.endDate,'YYYY') },
						  { name: "Total Night Stay", parameter: "{{total_night}}", value: moment.duration(moment(this.popup_filter.form.date.endDate).diff(moment(this.popup_filter.form.date.startDate))).days() },
						  { name: "Total Adult", parameter: "{{total_adult}}", value: this.popup_filter.form.guest.adult },
						  { name: "Total Child", parameter: "{{total_child}}", value: this.popup_filter.form.guest.child },
						  { name: "Total Infant", parameter: "{{total_infant}}", value: this.popup_filter.form.guest.infant },
						  { name: "Total Guest", parameter: "{{total_guest}}", value: Number(this.popup_filter.form.guest.adult)+Number(this.popup_filter.form.guest.child)+Number(this.popup_filter.form.guest.infant) },
						  { name: "Currency in ISO format", parameter: "{{currency_code}}", value: this.getCurrency.code },
						  { name: "Language Used", parameter: "{{langugae_code}}", value: this.getCurrentLanguage },
						  { name: "Promo Code", parameter: "{{promo_code}}", value: this.popup_filter.form.promo_code },
						]
      			params.forEach(item=>{
			        parsed_url = parsed_url.replaceAll(item.parameter,item.value)
			      })
      			this.$openLink(parsed_url,'_blank')
      			success()
      		}else{
	      		setTimeout(()=>{
	      			let params = {
	      				date: {
		        			check_in: this.popup_filter.form.date.startDate,
		        			check_out: this.popup_filter.form.date.endDate
		        		},
		        		guest:this.popup_filter.form.guest,
		        		promo_code: this.popup_filter.form.promo_code
	      			}
	      			this.setBeFilter(params)
	      			let data_room_type = {
	      				id: this.room_type_detail.id,
	      				name: this.room_type_detail.name
	      			}
	      			let params_room_type = {
								type: 'room_type',
								data: data_room_type
							}
							this.setBeFilterDetail(params_room_type)
	      			this.goToSearchRoom()
	      			success()
	      		},300)
      		}
      	})
      },
	    toggleCounter(data, category) {
		    if (data == 'plus' && category == 'adult') {
		      this.popup_filter.form.guest.adult++
		    } else if (data == 'min' && category == 'adult') {
		      this.popup_filter.form.guest.adult--
		      if (this.popup_filter.form.guest.adult <= 0) {
		        this.popup_filter.form.guest.adult = 0
		      }
		    } else if (data == 'plus' && category == 'child') {
		      this.popup_filter.form.guest.child++
		    } else if (data == 'min' && category == 'child') {
		      this.popup_filter.form.guest.child--
		      if (this.popup_filter.form.guest.child <= 0) {
		        this.popup_filter.form.guest.child = 0
		      }
		    } else if (data == 'plus' && category == 'infant') {
		      this.popup_filter.form.guest.infant++
		    } else if (data == 'min' && category == 'infant') {
		      this.popup_filter.form.guest.infant--
		      if (this.popup_filter.form.guest.infant <= 0) {
		        this.popup_filter.form.guest.infant = 0
		      }
		    }
		  },
		  showGallery(data){
      	this.is_gallery = data
      	document.querySelector('body').style.overflow = data ? 'hidden' : 'auto';
      },
      handlePopupFilter(){
      	this.popup_active = !this.popup_active
      },
      openGmaps(){
        let tag_a = document.createElement('a')
        tag_a.href = `https://maps.google.com/?q=${this.getMerchant.lat},${this.getMerchant.lng}`
        tag_a.target = '_blank'
        tag_a.click()
        tag_a.remove()
      },
      checkStatus(is_input_pin=false){
      	// type = ['input_pin','get_detail']
      	if(is_input_pin){
      		this.reservation_pin_error = ''
      		let regex_number_only = new RegExp('^[0-9]+$')
      		if(this.reservation_pin == ''){
      			this.reservation_pin_error = 'Please input PIN'
      		}else if(this.reservation_pin.includes(' ')){
      			this.reservation_pin_error = 'PIN cannot contain space'
      		}else if(regex_number_only.test(this.reservation_pin) == false){
      			this.reservation_pin_error = 'PIN can only contain number'
      		}else{
      			this.$emit('checkReservationStatus',{
		      		type: 'input_pin',
		      		pin: this.reservation_pin
		      	})
      		}
      	}else{
      		let type = ''
      		if(this.getConciergeAuth.pin != ''){
      			type = 'with_pin'
      		}else if(this.getConciergeAuth.detail_id != '' && this.getConciergeAuth.token != ''){
      			type = 'with_detail_id'
      		}else{
      			type = 'from_account'
      		}

      		this.$emit('checkReservationStatus',{
	      		type: type,
	      		pin: ''
	      	})
      	}
      },
      // ROOM TYPE
      loadRoomTypeDetail(){
				this.is_load = true
				return new Promise((success,fail)=>{
					get("CORE_HOTEL",`v2/room-type/${this.room_type_id}?merchant_id=${this.getMerchant.id}`).then(response=>{
						if (response.data.success) {
							this.room_type_detail = response.data.data
              applyResolvedTitle({router: this.$router, title: response.data.data.name, trackFn: () => {
                trackPageViewAfterDataLoaded()
              }})
							success()
						}else{
							fail(response.data.message)
						}
						this.is_load = false
					})
				})
			},
	  }
	}
</script>
<style>
.show-desktop{
  display: block;
}
.show-mobile{
  display: none;
}
.hide-576px{
  display: block;
}
.header-sticky{
	position: sticky;
	top: -1px;
	height: 80.8px;
	background-color: #fff;
	z-index: 9;
}
.hide-768px{
  display: block;
}
.show-768px{
  display: none;
}
@media screen and (max-width: 1200px) {
  .show-desktop{
    display: none;
  }
  .show-mobile{
    display: block;
  }
  .px-10{
    padding-left: 3rem;
    padding-right: 3rem;
  }
}
@media screen and (max-width: 768px) {
	.h-200px-m{
		height: 200px;
	}
	.hide-768px{
    display: none;
  }
  .show-768px{
    display: block;
  }
}
@media screen and (max-width: 576px) {
	.hide-576px{
	  display: none;
	}
  .px-10{
    padding-left: 24px;
    padding-right: 24px;
  }
  .text-20-m{
  	font-size: 20px!important;
  }
  .text-17-m{
  	font-size: 17px!important;
  }
  .text-14-m{
  	font-size: 14px!important;
  }
  .room-type-border-m{
  	border: 1px solid #ddd;
  	padding-bottom: 0px!important;
  	border-radius: 6px;
  }
  .room-type-desc-m{
  	padding: 16px!important;
  }
  .p-0-m{
  	padding: 0!important;
  }
	/* ROOM TYPE DETAIL */
	.text-26-m{
  	font-size: 26px!important;
  }
  .text-20-m{
  	font-size: 20px!important;
  }
  .text-16-m{
  	font-size: 16px!important;
  }
  .h-270px-m{
  	height: 270px!important;
  }
  .box-c-rt{
  	padding: 1rem 1.5rem !important;
  	margin-right: 12px;
  }
}
.box-c-rt{
	padding: 1.5rem 3rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/hotel/RoomTypeDetail.vue